window.addEventListener('DOMContentLoaded', () => {
  if (!customElements.get('sizechart-table')) {
    class sizeChart extends HTMLElement {
      constructor() {
        super();
        this.tagBtns = this.querySelectorAll('[data-tab-id]');
        this.tabContens = this.querySelectorAll('.tab-cotent');
        this.tableDatas = this.querySelectorAll('table td');
        this.tableHeading = this.querySelectorAll('table thead th');
        this.matrixTrigger = this.querySelectorAll('[data-matrix]');
        this.closeBtn = this.querySelector('.close-btn');
        this.optionRadios = document.querySelectorAll('.variant-input-wrap[name="SIZE"] input');
        this.init();
      }

      handleTab = () => {
        this.tagBtns.forEach(btn => {
          btn.addEventListener('click', (e) => {
            let that = e.currentTarget,
              tabIdEle = this.querySelector(`#${that.dataset.tabId}`);

            this.tagBtns.forEach(btn => btn.classList.remove('active'));
            this.tabContens.forEach(btn => btn.classList.remove('active'));
            that.classList.add('active');

            this.scrollTo({
              top: (tabIdEle.offsetTop - this.offsetTop) - 40,
              left: 0,
              behavior: "smooth",
            });
          })
        })
        this.addEventListener('scroll', () => {
          this.tabContens.forEach(content => {
            let contentOffsetTop = content.offsetTop - 250;
            let mainOffsetTop = this.scrollTop + this.offsetTop;
            if (mainOffsetTop >= contentOffsetTop) {
              this.tagBtns.forEach(btn => btn.classList.remove('active'));
              this.querySelector(`[data-tab-id="${content.id}"]`).classList.add('active');
            }
          })
        })
      }

      handleVariant = () => {
        this.tableDatas.forEach(td => {
          td.addEventListener('click', (e) => {
            let that = e.currentTarget;
            var checkEle =  that.closest('tr').querySelector('input');
            if (checkEle.classList.contains('offer-temp')) {
              let selectedSize = document.querySelectorAll('.size-chart-index tr');
              if (selectedSize) {
                selectedSize.forEach((button)=> {
                    button.addEventListener('click',(event)=> {
                      var newSelectedVal = button.querySelector('input[type="radio"]');
                      var selectedbuttonId = newSelectedVal.getAttribute('data-button-id');
                      var selectedVariantId = newSelectedVal.value;
                      var checkboxs = document.querySelectorAll('#'+selectedbuttonId+'[type="checkbox"]');
                      checkboxs.forEach(checkbox => {
                          checkbox.setAttribute("data-id-variant", selectedVariantId);
                      });
                  })
                })
              }
            }  
            let sizeTitle = that.closest('tr').querySelector('input').dataset.sizeName;

            that.closest('table').querySelectorAll('tr').forEach(tr => tr.classList.remove('selected'));

            that.closest('tr').querySelector('input').checked = true;

            that.closest('.quick_pop_data').querySelector(`.variant-input[data-value="${sizeTitle}"] input`).click();

            that.closest('tr').classList.add('selected');
          })
        })
      }
      toggleMeasurement = () => {
        this.matrixTrigger.forEach(btn => {
          btn.addEventListener('click', (e) => {
            let matrix = e.currentTarget.dataset.matrix;

            if (e.currentTarget.classList.contains('active')) return;

            this.matrixTrigger.forEach(btn => btn.classList.remove('active'));
            e.currentTarget.classList.add('active');
            if (matrix == 'in') {
              this.tableDatas.forEach(td => {
                if (td.classList.contains('chart-value')) {
                  td.textContent = (parseFloat(td.textContent) / 2.54).toFixed(1);
                  this.tableHeading.forEach(th => th.setAttribute('data-matix','in'));
                }
              });
            } else {
              this.tableDatas.forEach(td => {
                if (td.classList.contains('chart-value')) {
                  td.textContent = (parseFloat(td.textContent) * 2.54).toFixed(1);
                  this.tableHeading.forEach(th => th.setAttribute('data-matix','cm'));
                }
              });
            }
          })
        })
      }

      handleGridClick = () => {
        // work this JS only when its a product page...
        if (document.body.classList.contains('template-product')) {
          // change variant when user arrives from grid-item..
          let getVariant = localStorage.getItem("prd_grid_variant");
          if (getVariant) {
            let variantObj = JSON.parse(getVariant);
            let productVar = variantObj.selected_var;
            let productId = variantObj.product_id;
    
            let currentPrd = document.querySelectorAll('sizechart-table [data-size-name]');
            if (currentPrd) {
              currentPrd.forEach((radioBtn) => {
                let currProduct = radioBtn.closest('[data-product-id]');
                if (currentPrd) {
                  let currentPrdId = currProduct.dataset.productId;
                  let currSize = radioBtn.getAttribute('data-size-name');
                  if (currSize == productVar && currentPrdId == productId) {
                    radioBtn.click();
                    radioBtn.checked === true;
                    radioBtn.closest('td').click();
                  }
                }
              })
            }
          }
        }
      }

      closePopup = () => {
        this.closeBtn.addEventListener('click', () => {
          this.closest('.size-chart-index').classList.remove('active');
          document.body.style.overflow = null;
        })
      }

      init = () => {
        this.handleTab();
        this.handleVariant();
        this.toggleMeasurement();
        this.closePopup();
        this.handleGridClick();
      }
    }
    customElements.define('sizechart-table', sizeChart);
    let sizeChartTrigger = document.querySelector('#sizeguideTrigger');
    if(sizeChartTrigger){
      sizeChartTrigger.addEventListener('click', (e) => {
      let size_chart_index = document.querySelector('.size-chart-index')
      size_chart_index.classList.add('active')
      gtag("event", "size_chart_btn_hit", {
        page_location: window.location.href
      });
      e.preventDefault();
      // if (window.innerWidth > 767 && __st.rtyp == 'product') {
      //   let sizeChartAcco = document.querySelector('a[href="#sizeguide"]');
      //   sizeChartAcco.classList.add('active');
      //   sizeChartAcco.closest('.cust-accordion').querySelector('.acco-content').style.display = 'block';

      //   let offsetTop = sizeChartAcco.offsetTop - 50 - document.querySelector('#SiteHeader').clientHeight;
      //   window.scrollTo({
      //     top: offsetTop,
      //     left: 0,
      //     behavior: "smooth", 
      //   })
      // } else {
      //   document.body.style.overflow = 'hidden';
      //   document.querySelector('.size-chart-index').classList.add('active');
      //   document.querySelector('.size-chart-acco-wrapper .acco-title').classList.add('active');
      //   document.querySelector('.size-chart-acco-wrapper .acco-content').style.display = 'block';
      // }
    })
    }

    let sizeVarTrigger = document.querySelector('#sizevarTrigger');
    if(sizeVarTrigger){
        sizeVarTrigger.addEventListener('click', (e) => {
        e.preventDefault();
        if (window.innerWidth <= 767 && __st.rtyp == 'product') {
          document.body.style.overflow = 'hidden';
          document.querySelector('.size-chart-index').classList.add('active');
          document.querySelector('.size-chart-acco-wrapper .acco-title').classList.add('active');
          document.querySelector('.size-chart-acco-wrapper .acco-content').style.display = 'block';
        }
      })
    }


  }
})